import { useEffect, useState } from 'react';
import { updateAppSettingsSchema } from '@wingseat/shared';
import {
  useAdminSettings,
  useUpdateAdminSettings,
} from '../../hooks/use-admin';
import { ApiError } from '../../lib/api-client';

export function AdminSettingsPage() {
  const get = useAdminSettings();
  const update = useUpdateAdminSettings();
  const [expiry, setExpiry] = useState('');
  const [err, setErr] = useState<string | null>(null);

  useEffect(() => {
    if (get.data) setExpiry(String(get.data.offerExpiryOffsetMinutes));
  }, [get.data]);

  const onSave = () => {
    const parsed = updateAppSettingsSchema.safeParse({
      offerExpiryOffsetMinutes: Number(expiry),
    });
    if (!parsed.success) {
      setErr(parsed.error.issues[0]?.message ?? 'Ungültig');
      return;
    }
    setErr(null);
    update.mutate(parsed.data);
  };

  const apiErr = update.error instanceof ApiError ? update.error.message : null;

  return (
    <div className="px-4 py-4 space-y-4">
      <h1 className="text-xl font-semibold">App-Settings</h1>

      <section className="rounded-xl border border-slate-800 bg-slate-900/60 p-3 space-y-3">
        <div>
          <label className="block text-xs text-slate-400">
            Ablauf-Vorlauf (Minuten)
          </label>
          <input
            type="number"
            min={0}
            max={1440}
            value={expiry}
            onChange={(e) => setExpiry(e.target.value)}
            className="mt-1 w-full rounded-lg border border-slate-700 bg-slate-950 px-3 py-2 text-base"
          />
          <p className="mt-1 text-xs text-slate-500">
            Flüge laufen automatisch ab, sobald <code>now</code> &gt;= <code>startAt</code> minus diesem Wert ist.
          </p>
        </div>
        {err && <p className="text-xs text-rose-400">{err}</p>}
        {apiErr && <p className="text-xs text-rose-400">{apiErr}</p>}
        {update.isSuccess && !apiErr && (
          <p className="text-xs text-emerald-400">Gespeichert.</p>
        )}
        <button
          onClick={onSave}
          disabled={update.isPending}
          className="w-full rounded-lg bg-brand-600 px-4 py-2.5 font-medium hover:bg-brand-700 disabled:opacity-60"
        >
          {update.isPending ? 'Speichert …' : 'Speichern'}
        </button>
      </section>
    </div>
  );
}
